// W13 (R-N, 47034): GET /customers/:id/applicable-sources?operation_id= lists what can pay an order: money, credit and vouchers, each with its cap (server text).
// Degrades silently: an API without the route (404) or any failure = null (the door then offers money and credit only).
import { useEffect, useState } from 'react';
import api from '../../../services/api';

export default function useApplicableSources(partnerId, op) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!partnerId || !op) return undefined;
    let live = true;
    Promise.resolve(api.request(`/customers/${encodeURIComponent(partnerId)}/applicable-sources?operation_id=${encodeURIComponent(op)}`))
      .then(r => { if (live) setSrc(r && Array.isArray(r.vouchers) ? r : null); }).catch(() => { if (live) setSrc(null); });
    return () => { live = false; };
  }, [partnerId, op]);
  return src;
}
